var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminsend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_18496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38281 16.8779V21.3227C8.38281 21.6332 8.58215 21.9082 8.87731 22.006C8.9511 22.0299 9.02681 22.0414 9.10156 22.0414C9.32581 22.0414 9.5424 21.936 9.6804 21.7482L12.2804 18.21L8.38281 16.8779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6982 0.133293C22.4778 -0.0229151 22.1883 -0.0439984 21.9488 0.0815433L0.386251 11.342C0.131334 11.4752 -0.019124 11.7473 0.00195929 12.0339C0.024001 12.3214 0.214709 12.5667 0.485918 12.6597L6.48029 14.7086L19.2463 3.79317L9.36775 15.6947L19.414 19.1284C19.4887 19.1533 19.5673 19.1668 19.6459 19.1668C19.7762 19.1668 19.9056 19.1313 20.0196 19.0623C20.2017 18.9511 20.3253 18.7643 20.357 18.5544L22.9924 0.82521C23.0317 0.556877 22.9186 0.29046 22.6982 0.133293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_18496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminsend);
export default __webpack_public_path__ + "static/media/adminsend.9ee5c314fe221faeaf5f3ce04df2030c.svg";
export { ForwardRef as ReactComponent };